import api from "./api";

export const putMembership = async (id, body) => {
  return api
    .put({
      body,
      port: process.env.REACT_APP_PORT_VENUE,
      endpoint: `/member/by-owner/${id}`,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
